<template>
<div class="jurisdiction-count">
    <div class="jurisdiction-count__chart"><Chart :options="chartOptions" class="policy-item-chart"/> <h4 class="f-title-6">{{ inForce }}</h4></div>
    <p class="jurisdiction-count__label f-ui-3">{{ inForce === 1 ? 'jurisdiction' : 'jurisdictions'}}</p>
</div>
</template>

<script>
import {Chart} from 'highcharts-vue';
export default {
    props: {
        inForce: {
            type: Number,
            default : 0
        },
        announced: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 50
        }
    },
    components: { Chart },
    computed: {
        chartOptions() {
            const { inForce, announced, total } = this;
            return {
                chart: {
                    type: 'item',
                    styledMode: true,
                    height:32,
                    width: 80,
                    spacing: 0,
                    margin: 0
                },
                title: {
                    text: null
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                tooltip: {
                    outside: true,
                    className: 'item-chart-tooltip'
                },
                series: [
                    { 
                        name: 'Jurisdictions',
                        data: [
                            ['Policy in force', inForce],
                             ['Announced policy', announced],
                            ['No policy', total - inForce - announced]
                        ],
                        rows: 4,
                        /*
                        center: ['50%', '88%'],
                        rows: 5,
    size: '160%',
    startAngle: -90,
    endAngle: 90,
    */
    dataLabels: {
        enabled: false
    }
                    }
                ]
            }
        }
    }
}
</script>

<style>
.jurisdiction-count {
    display: flex;
    gap: 4px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.policy-item-chart .highcharts-background {
    fill: transparent;
}
.policy-item-chart .highcharts-point.highcharts-color-0, .item-chart-tooltip.highcharts-label tspan.highcharts-color-0 {
    fill: #04f;
    stroke: #04f;
}
.policy-item-chart .highcharts-point.highcharts-color-1 {
    fill: transparent;
    stroke: #04f;
}
.item-chart-tooltip.highcharts-label tspan.highcharts-color-1 {
    fill: transparent;
    stroke: #04f;
    stroke-width: 1px;
}
.policy-item-chart .highcharts-point.highcharts-color-2, .item-chart-tooltip.highcharts-label tspan.highcharts-color-2 {
    fill: #e4e4e4;
    stroke: #e4e4e4;
}
.jurisdiction-count__chart {
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    margin: 0px 8px;
}
.jurisdiction-count__chart .f-title-6 {
    margin: 0px;
}
.jurisdiction-count__chart .highcharts-container{
    max-width: 80px;
}
.jurisdiction-count__label {
    color: #949494;
    margin-left: 8px;
}
</style>
